import { gql } from "@apollo/client"

export const GET_ORGANIZATION_PENDING_INVITES = gql`
  query getPendingOrganizationInvites($orgId: ID!) {
    pendingInvitations(orgId: $orgId) {
      id
      toUser
      organization {
        id
        name
      }
      initialGroup {
        id
        name
        organizationGroup {
          id
          name
        }
      }
    }
  }
`
